import React from 'react';
import PropTypes from 'prop-types';

import { Card } from 'react-bootstrap-5';

import AvailableUsers from './available_users';
import SelectedUsers from './selected_users';

// TODO: Should use a generic multiselect component, as we do in the multiselect modal
const UserSelector = ({ selectedUserIds, users, onChange }) => (
  <div className="row">
    <div className="col-6">
      <Card>
        <Card.Header>
          <h6>Disabled Users</h6>
        </Card.Header>
        <Card.Body>
          <AvailableUsers
            selectedUserIds={selectedUserIds}
            users={users}
            onChange={onChange}
          />
        </Card.Body>
      </Card>
    </div>

    <div className="col-6">
      <Card>
        <Card.Header>
          <h6>Enabled Users</h6>
        </Card.Header>
        <Card.Body>
          <SelectedUsers
            selectedUserIds={selectedUserIds}
            users={users}
            onChange={onChange}
          />
        </Card.Body>
      </Card>
    </div>
  </div>
);

UserSelector.propTypes = {
  selectedUserIds: PropTypes.array.isRequired,
  users: PropTypes.array.isRequired,

  onChange: PropTypes.func.isRequired
};

export default UserSelector;
